import { MarkerClusterer } from "@googlemaps/markerclusterer";

class MapManager {
    constructor(mapElementId) {
        this.mapElementId = mapElementId;
        this.jsonData = [];
        this.markers = [];
        this.map = null;
        this.markerClusterer = null;
        this.activeMarker = null;

        this.init();
    }

    async init() {
        this.customInfoWindow = document.getElementById("custom-info-window");
        // Fetch the JSON data from the script tag
        const jsonDataElement = document.getElementById("json-data");
        this.jsonData = jsonDataElement
            ? JSON.parse(jsonDataElement.innerHTML)
            : [];
        await this.initMap();
    }

    async initMap() {
        // Request needed libraries.
        const { Map, InfoWindow } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement, PinElement } =
            await google.maps.importLibrary("marker");
        this.map = new Map(document.getElementById("map"), {
            zoom: 3,
            center: { lat: 50.835200999999998, lng: -0.080208199999999993 }, // Initial center point
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            zoomControl: false,
            mapId: "1ffb7e144b58aed6",
        });

        const infoWindow = new InfoWindow({
            content: "",
            disableAutoPan: true,
        });

        // Function to add zoom controls
        this.zoomControls();

        // Function to update the markers based on filtered data
        const updateMarkers = (filteredData) => {
            //hide modal
            this.customInfoWindow.style.display = "none";
            // Clear existing markers
            this.markers.forEach((marker) => marker.setMap(null));
            this.markers.length = 0; // Reset the markers array

            // Remove the previous clusterer if it exists
            if (this.markerClusterer) {
                this.markerClusterer.clearMarkers();
            }

            const bounds = new google.maps.LatLngBounds();

            filteredData.forEach((item, i) => {
                // Check if locations exists and is a non-empty array
                if (
                    item.locations &&
                    Array.isArray(item.locations) &&
                    item.locations.length > 0
                ) {
                    item.locations.forEach((location) => {
                        const lat = parseFloat(location.lat);
                        const lng = parseFloat(location.lng);

                        // Check if the latitude and longitude are valid numbers
                        if (!isNaN(lat) && !isNaN(lng)) {
                            const Neutral =
                                item.project_status == "Active" ||
                                item.project_status == "Available to Tour" ||
                                !("project_status" in item)
                                    ? false
                                    : true;

                            const markerImgUrlOrange =
                                "https://col-new-development.cogdesign.com/wp-content/themes/col-theme/public/images/single_current_default_25x28.png";
                            const hoverImgUrlOrange =
                                "https://col-new-development.cogdesign.com/wp-content/themes/col-theme/public/images/single_current_hover_25x28.png";
                            const activeImgUrlOrange =
                                "https://col-new-development.cogdesign.com/wp-content/themes/col-theme/public/images/single_current_selected_25x28.png";
                            const markerImgUrlNeutral =
                                "https://col-new-development.cogdesign.com/wp-content/themes/col-theme/public/images/single_past_default_25x28.png";
                            const hoverImgUrlNeutral =
                                "https://col-new-development.cogdesign.com/wp-content/themes/col-theme/public/images/single_past_hover_25x28.png";
                            const activeImgUrlNeutral =
                                "https://col-new-development.cogdesign.com/wp-content/themes/col-theme/public/images/single_past_selected_25x28.png";

                            const markerImgUrl = Neutral
                                ? markerImgUrlNeutral
                                : markerImgUrlOrange;
                            const hoverImgUrl = Neutral
                                ? hoverImgUrlNeutral
                                : hoverImgUrlOrange;
                            const activeImgUrl = Neutral
                                ? activeImgUrlNeutral
                                : activeImgUrlOrange;

                            const offset = 0.00003;
                            //console.log('offset', offset * (i % 10))
                            const position = {
                                lat: lat + offset * (i % 10),
                                lng: lng + offset * Math.floor(i / 10),
                            };

                            // Create a marker with initial content as an image element
                            const markerImage = document.createElement("img");
                            markerImage.src = markerImgUrl;
                            markerImage.style.width = "26px";
                            markerImage.style.height = "28px";

                            const marker = new AdvancedMarkerElement({
                                position,
                                content: markerImage,
                            });

                            marker.imageElement = markerImage;

                            // Add mouse event listeners for hover effect
                            marker.content.addEventListener(
                                "mouseenter",
                                () => {
                                    // Change the image on hover
                                    markerImage.src = hoverImgUrl; // Change to hover image
                                },
                            );

                            marker.content.addEventListener(
                                "mouseleave",
                                () => {
                                    // Revert the image back to the original only if this marker is not active
                                    if (this.activeMarker !== marker) {
                                        markerImage.src = markerImgUrl; // Change back to original image
                                    }
                                },
                            );

                            // Open info window when marker is clicked
                            marker.addListener("click", () => {
                                // Log the current active marker
                                console.log(
                                    "Current Active Marker:",
                                    this.activeMarker,
                                );

                                // Check if there is an active marker
                                if (this.activeMarker) {
                                    if (this.activeMarker.imageElement) {
                                        this.activeMarker.imageElement.src =
                                            markerImgUrl; // Reset to original icon
                                    }
                                }

                                // Set the active marker and change its icon
                                this.activeMarker = marker;
                                markerImage.src = activeImgUrl;

                                const customInfoWindow =
                                    document.getElementById(
                                        "custom-info-window",
                                    );
                                const partnershipTag =
                                    item.partnership &&
                                    item.partnership.length > 0
                                        ? `<p class="card__parntership mb-0">${item.partnership}</p>`
                                        : "";
                                const tagBgColor =
                                    (item.project_status &&
                                        item.project_status === "Active") ||
                                    (item.project_status &&
                                        item.project_status ===
                                            "Available to Tour")
                                        ? `has-brand-1-background-color`
                                        : `has-neutral-700-background-color detail-color-neutral-700 color--white`;
                                const projectStatusTag =
                                    item.project_status &&
                                    item.project_status.length > 0
                                        ? `<span class="card__image-tag ${tagBgColor} diagonal-detail-before type-body-s fw-b">${item.project_status}</span>`
                                        : "";
                                const summaryTag = item.summary
                                    ? `<p class="card__summary">${item.summary}</p>`
                                    : "";
                                const attributionTag = item.attribution
                                    ? `<p class="card__attribution mt-0">${item.attribution}</p>`
                                    : "";
                                const is_project =
                                    document.body.classList.contains(
                                        "page-template-project-listing",
                                    );
                                const projectTitle = is_project
                                    ? `<p class="card__type fw-m mt-0">Project</p>`
                                    : "";
                                const postType = is_project
                                    ? "project"
                                    : "artist";
                                const content = `
                                    <div class="card card--${postType} margin-trim">
                                        <div class="close-window">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8.5 11.5H0V8.5H8.5V0H11.5V8.5H20V11.5H11.5V20H8.5V11.5Z" fill="black"/>
                                            </svg>
                                        </div>
                                        ${partnershipTag}
                                        <div class="card__heading--wrapper margin-trim stack stack--s">
                                            <h4 class="card__heading">${item.title}</h4>
                                            ${attributionTag}
                                        </div>
                                        ${summaryTag}
                                        <div class="card__image img-fit">
                                            <img src="${item.image_url}" alt="${item.title}">
                                            <a href="${item.link}" target="_blank" class="link-icon">
                                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g><path d="M10.125 30L8 27.875L24.875 11H10V8H30V28H27V13.125L10.125 30Z" fill="black"/></g>
                                                </svg>
                                            </a>
                                             ${projectStatusTag}
                                        </div>
                                         <div class="card__actions">
                                            <a href="${item.link}" class="card__btn card__fill-link"></a>
                                         </div>
                                    </div>`;
                                customInfoWindow.querySelector(
                                    "#custom-info-window__content",
                                ).innerHTML = content;
                                customInfoWindow.style.display = "block";
                                this.closeInfoWindow();
                            });

                            this.markers.push(marker);
                            marker.setMap(this.map); // Add the marker to the map

                            bounds.extend(marker.position);
                        }
                    });
                }
            });

            // Create a new MarkerClusterer with the updated markers
            this.markerClusterer = new MarkerClusterer({
                markers: this.markers,
                map: this.map,
                renderer: {
                    render: ({ markers, _position: position }) => {
                        const clusterIcon = new google.maps.Marker({
                            position: {
                                lat: position.lat(),
                                lng: position.lng(),
                            },
                            label: {
                                text: String(markers.length),
                                color: "black",
                                fontSize: "18px",
                                fontFamily: "neue-haas-grotesk-display",
                            },
                            icon: {
                                url: "https://col-new-development.cogdesign.com/wp-content/themes/col-theme/public/images/cluster-image-orange.png",
                                size: new google.maps.Size(40, 40),
                                scaledSize: new google.maps.Size(40, 40),
                                anchor: new google.maps.Point(20, 20), // Anchor to the center of the image
                            },
                        });

                        // Create rollover effect using event listeners
                        google.maps.event.addListener(
                            clusterIcon,
                            "mouseover",
                            () => {
                                clusterIcon.setIcon({
                                    url: "https://col-new-development.cogdesign.com/wp-content/themes/col-theme/public/images/cluster-image-black.png",
                                    size: new google.maps.Size(40, 40),
                                    scaledSize: new google.maps.Size(40, 40),
                                    anchor: new google.maps.Point(20, 20),
                                });

                                // Change the label color to white on hover
                                clusterIcon.setLabel({
                                    text: String(markers.length),
                                    color: "white", // Change text color to white on hover
                                    fontSize: "18px",
                                    fontFamily: "neue-haas-grotesk-display",
                                });
                            },
                        );

                        google.maps.event.addListener(
                            clusterIcon,
                            "mouseout",
                            () => {
                                clusterIcon.setIcon({
                                    url: "https://col-new-development.cogdesign.com/wp-content/themes/col-theme/public/images/cluster-image-orange.png",
                                    size: new google.maps.Size(40, 40),
                                    scaledSize: new google.maps.Size(40, 40),
                                    anchor: new google.maps.Point(20, 20),
                                });

                                clusterIcon.setLabel({
                                    text: String(markers.length),
                                    color: "black", // Change text color to white on hover
                                    fontSize: "18px",
                                    fontFamily: "neue-haas-grotesk-display",
                                });
                            },
                        );

                        return clusterIcon;
                    },
                },
            });

            // Zoom the map to fit the bounds of the newly loaded markers
            if (filteredData.length > 0) {
                this.map.fitBounds(bounds);
            } else {
                // If no markers are left after the filter, reset the zoom to level 3
                this.map.setZoom(3);
            }
        };

        // Initial population of the map with all markers
        updateMarkers(this.jsonData);

        // Listen for the filter update event
        document.addEventListener("filterUpdate", (event) => {
            updateMarkers(event.detail); // Call updateMarkers with the filtered data
        });
    }

    zoomControls() {
        const zoomInButton = document.getElementById("zoom-in");
        const zoomOutButton = document.getElementById("zoom-out");
        const zoomOutRefresh = document.getElementById("zoom-refresh");

        zoomInButton.addEventListener("click", () => {
            if (this.map) {
                this.map.setZoom(this.map.getZoom() + 1); // Zoom in
            }
        });

        zoomOutButton.addEventListener("click", () => {
            if (this.map) {
                this.map.setZoom(this.map.getZoom() - 1); // Zoom out
            }
        });

        zoomOutRefresh.addEventListener("click", () => {
            if (this.map) {
                this.resetZoom();
            }
        });
    }

    resetZoom() {
        // Reset the map's zoom level back to 3
        if (this.map) {
            this.map.setZoom(3);
        }
    }

    closeInfoWindow() {
        const closeButton = document.querySelector(".close-window");
        const customInfoWindow = document.getElementById("custom-info-window");
        closeButton.addEventListener("click", () => {
            customInfoWindow.style.display = "none";
        });
    }
}

export default MapManager;
